import { atom } from "@reatom/framework";

export const isOpenPromotionModalAtom = atom(false, "isOpenPromotionModalAtom");
